import { SimNaoEnum } from 'components/form'

import { PodeNaoPodeEnum } from '../../model-consultaSeguimento'
import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta18ExemplosEnum,
  ConsultaSeguimentoPergunta18Model,
} from './model-consultaSeguimentoPergunta18'

const pergunta18ExemplosEnum = Object.values(ConsultaSeguimentoPergunta18ExemplosEnum)

export const isPergunta18ExemplosAllNao = (
  value: ConsultaSeguimentoPergunta18Model['PERGUNTA_18_EXEMPLOS']
): boolean => {
  return isAllNao(value, pergunta18ExemplosEnum)
}

export function prunePergunta18(value: ConsultaSeguimentoPergunta18Model): ConsultaSeguimentoPergunta18Model {
  const pruned: ConsultaSeguimentoPergunta18Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_18_HEADER: value.PERGUNTA_18_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_18_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_18_HEADER === SimNaoEnum.NAO
  const isPodeNaoPodeNaoPode = value.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE
  const isSegueOrdemNao = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO
  const isSegueOrdemSim = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM
  const isSentaAMesaSim = value.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM

  const shouldShowMainPath = isHeaderNao || (isHeaderSim && isPodeNaoPodeNaoPode)
  const shouldShowExemplos = isSegueOrdemSim || (isSegueOrdemNao && isSentaAMesaSim)

  if (isHeaderSim) {
    pruned.PERGUNTA_18_PODE_NAO_PODE = value.PERGUNTA_18_PODE_NAO_PODE
  }

  if (shouldShowMainPath) {
    pruned.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM
  }

  if (shouldShowMainPath && isSegueOrdemNao) {
    pruned.PERGUNTA_18_SENTA_A_MESA = value.PERGUNTA_18_SENTA_A_MESA
  }

  if (shouldShowMainPath && shouldShowExemplos) {
    pruned.PERGUNTA_18_EXEMPLOS = value.PERGUNTA_18_EXEMPLOS
  }

  return pruned
}
